// extracted by mini-css-extract-plugin
module.exports = {"main":"BBPicture_main__3qv3N","list":"BBPicture_list__C2hYj","firstItemBold":"BBPicture_firstItemBold__2TZae","link":"BBPicture_link__1X6dP"};